import { SVGInterface } from "../../interface";

const Navigation = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12.4798 7.86994L16.5798 18.3L13.2898 16.7699L12.4798 16.4099L11.6698 16.7699L8.0198 18.3L12.4798 7.86994ZM12.4798 2.59994L4.7998 20.89L5.5098 21.6L12.4798 18.5999L19.0898 21.6L19.7998 20.89L12.4798 2.59994Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Navigation;
